/* @generated */

// src/assets/ui-icon/line/lightbulb.tsx
import * as React from "react";
var LightbulbLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.004 15.5C6.988 14.686 6 12.866 6 10c0-4.038 1.962-6 6-6s6 1.962 6 6c0 2.865-.988 4.685-3.004 5.5H15V17H9v-1.5h.004Zm2.246-1.027c-1.348-.106-2.184-.5-2.704-1.02C7.936 12.845 7.5 11.799 7.5 10c0-1.798.437-2.844 1.046-3.454C9.156 5.936 10.202 5.5 12 5.5c1.798 0 2.844.437 3.454 1.046.61.61 1.046 1.656 1.046 3.454 0 1.798-.437 2.844-1.046 3.454-.52.52-1.356.913-2.704 1.019v-1.664l1.654-1.654-1.06-1.06-1.345 1.344-1.345-1.345-1.06 1.06 1.656 1.657v1.662Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement("path", { d: "M9 18.502v1.5h6v-1.5H9Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }));
export {
  LightbulbLine
};
